import { useState } from "react"
import { Stack } from "@mui/material"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { Repeat } from "lib/@components/repeat"
import { Bound } from "lib/@components/binding/Bound"
import { NoResults } from "lib/@components/no-results/no-results"
import { ComponentInUseItem } from "./component-in-use-item"
import { ComponentInUseDetail } from "./component-in-use-detail"
import { FitInRemainingSpace } from "lib/@components/fit-in-remaining-space"

export function ComponentsInUseList({ componentTokenIds = [], scheduleTasks = [] }) {
    const [selectedTokenId, setSelectedTokenId] = useState(null)

    return (
        <If truthy={!selectedTokenId}>
            <If truthy={componentTokenIds.length > 0}>
                <FitInRemainingSpace setHeight leaveSpace={32}>
                    <Stack spacing={0}>
                        <Bound onSelect={setSelectedTokenId}>
                            <Repeat list={componentTokenIds} item={<ComponentInUseItem />} />
                        </Bound>
                    </Stack>
                </FitInRemainingSpace>
                <Else>
                    <NoResults mt={0} width={220}>
                        No components in use.
                    </NoResults>
                </Else>
            </If>
            <Else>
                <ComponentInUseDetail tokenId={selectedTokenId} onBack={handleBack} scheduleTasks={scheduleTasks} />
            </Else>
        </If>
    )

    function handleBack() {
        setSelectedTokenId(null)
    }
}
